
import { defineComponent } from "vue";
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src
import axios from "axios";

export default defineComponent({
  name: "Contact",
  components: {
    TitlebarButtons
  },
  data: () => ({
    current: {},
    filter: "",
    contacts: [] as {
      firstname: string;
      lastname: string;
      category: string;
      title: string;
      contactInfos: { key: string; value: string }[];
    }[]
  }),
  emits: ["update-focus", "update-maximization"],
  created: function() {
    axios
      .get("./_content/contacts.json")
      .then((response) => {
        this.contacts = response.data?.sort((c1: any, c2: any) =>
          c2.lastname > c1.lastname ? -1 : 1
        );
        this.current = this.contacts?.[0];
      })
      .catch((error) => console.error(error));
  },
  methods: {
    updateFocus(focusValue: string) {
      this.$emit("update-focus", focusValue);
    },
    updateMaximization() {
      this.$emit("update-maximization", "contact");
    },
    filteredContacts() {
      return !this.filter
        ? this.contacts
        : this.contacts.filter((c) => {
            const fa = this.filter?.split(" ");
            return fa?.some(
              (f) =>
                c.firstname?.toLowerCase().match(f.toLowerCase()) ||
                c.lastname?.toLowerCase().match(f.toLowerCase()) ||
                c.title?.toLowerCase().match(f.toLowerCase()) ||
                c.category?.toLowerCase().match(f.toLowerCase()) ||
                c.contactInfos?.some((ci) =>
                  ci.value.toLowerCase().match(f.toLowerCase())
                )
            );
          });
    },
    getCategories() {
      return this.contacts
        ?.map((i) => i.category)
        ?.filter((value, index, self) => self.indexOf(value) === index);
    },
    getContactLetter() {
      return this.filteredContacts()
        ?.map((c) => c.lastname.charAt(0).toUpperCase())
        ?.filter((value, index, self) => self.indexOf(value) === index)
        ?.sort();
    },
    getContactsByLetter(letter: string) {
      return this.filteredContacts()?.filter(
        (value) => value.lastname.charAt(0).toUpperCase() === letter
      );
    }
  }
});
